import { Component, OnInit } from '@angular/core';
import { BaseLoginComponent } from 'src/app/shared/components/base-login/base-login.component';

@Component({
  selector: 'app-hayfever-forgot-password',
  templateUrl: './hayfever-forgot-password.component.html',
  styleUrls: [
    '../style/global.css',
    './hayfever-forgot-password.component.css',
  ],
})
export class HayfeverForgotPasswordComponent
  extends BaseLoginComponent
  implements OnInit
{
  async init(): Promise<void> {}
}
